var React = require('react');

function ForwardarrowInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},[React.createElement("path",{"d":"M21.1973 0.638428L41.5814 21.0226L21.1973 41.4067","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M41.5811 21.0226L0 21.0226","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"42.858","height":"42.0453","fill":"white"})))]);
}

ForwardarrowInline.defaultProps = {"width":"43","height":"43","viewBox":"0 0 43 43","fill":"none"};

module.exports = ForwardarrowInline;

ForwardarrowInline.default = ForwardarrowInline;
